"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = theme => ({
  chip: {
    marginRight: 4,
    marginBottom: 2,
    display: 'inline-flex',
    background: theme.chip.background,
    borderColor: theme.chip.borderColor,
    borderWidth: 1,
    borderStyle: 'solid',
    padding: '0 12px',
    boxSizing: 'border-box',
    alignItems: 'center',
    position: 'relative'
  },
  avatar: {
    marginLeft: -12,
    marginRight: 8,
    width: 30,
    height: 30
  },
  label: {
    maxWidth: theme.chip.maxLengthText,
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
  },
  icon: {
    marginRight: 8
  },
  closeIcon: {
    cursor: 'pointer',
    marginLeft: 8,
    color: theme.chip.closeIconColor
  },
  small: {
    height: theme.chip.small.height,
    '& $avatar': {
      width: 18,
      height: 18
    }
  },
  medium: {
    height: theme.chip.medium.height
  },
  large: {
    height: theme.chip.large.height,
    '& $avatar': {
      width: 38,
      height: 38
    }
  },
  rounded: {
    borderRadius: theme.chip.medium.height / 2,
    '&$small': {
      borderRadius: theme.chip.small.height / 2
    },
    '&$large': {
      borderRadius: theme.chip.large.height / 2
    }
  },
  rectangular: {
    borderRadius: theme.chip.medium.rectangular.borderRadius,
    '&$small': {
      borderRadius: theme.chip.small.rectangular.borderRadius,
      '& $avatar': {
        borderRadius: theme.chip.small.rectangular.borderRadius
      }
    },
    '&$large': {
      borderRadius: theme.chip.large.rectangular.borderRadius,
      '& $avatar': {
        borderRadius: theme.chip.large.rectangular.borderRadius
      }
    },
    '& $avatar': {
      borderRadius: theme.chip.medium.rectangular.borderRadius
    }
  }
});

exports.default = _default;